import { z } from "zod";
import { paginationSchema, sortSchema } from "./pagination";

/**
 * HCA Moravia — validační schémata pro tag systém (plán §S.2.9).
 */

export const tagBarvaEnum = z.enum(["slate", "emerald", "blue", "amber", "red", "violet", "pink"]);
export type TagBarva = z.infer<typeof tagBarvaEnum>;

const uuidMsg = "Neplatné UUID";
const nazevField = z
  .string()
  .min(1, "Název je povinný")
  .max(100, "Název musí být 100 znaků nebo méně");

export const createTagSchema = z.object({
  nazev: nazevField,
  barva: tagBarvaEnum.default("slate"),
  popis: z.string().max(1000, "Popis musí být 1000 znaků nebo méně").optional(),
});

export const updateTagSchema = z.object({
  id: z.string().uuid(uuidMsg),
  nazev: nazevField.optional(),
  barva: tagBarvaEnum.optional(),
  popis: z.string().max(1000, "Popis musí být 1000 znaků nebo méně").nullable().optional(),
});

/** Whitelist řazení štítků — router mapuje klíče na sloupce. */
export const TAGS_SORT_KEYS = ["nazev", "pouziti"] as const;
export type TagsSortKey = (typeof TAGS_SORT_KEYS)[number];

export const listTagsSchema = paginationSchema.merge(sortSchema(TAGS_SORT_KEYS)).extend({
  search: z.string().max(255, "Hledaný text musí být 255 znaků nebo méně").optional(),
  includeArchived: z.coerce.boolean().optional(),
});

export const tagIdSchema = z.object({
  id: z.string().uuid(uuidMsg),
});

export const assignTagSchema = z.object({
  klientId: z.string().uuid(uuidMsg),
  tagId: z.string().uuid(uuidMsg),
  poznamka: z.string().max(500, "Poznámka musí být 500 znaků nebo méně").optional(),
});

export const removeTagSchema = z.object({
  klientId: z.string().uuid(uuidMsg),
  tagId: z.string().uuid(uuidMsg),
});

export const listKlientTagsSchema = z.object({
  klientId: z.string().uuid(uuidMsg),
});

export const bulkAssignTagsSchema = z.object({
  klientIds: z
    .array(z.string().uuid(uuidMsg))
    .min(1, "Vyberte alespoň jednoho klienta")
    .max(500, "Maximálně 500 klientů najednou"),
  tagId: z.string().uuid(uuidMsg),
  poznamka: z.string().max(500, "Poznámka musí být 500 znaků nebo méně").optional(),
});

export type CreateTagInput = z.infer<typeof createTagSchema>;
export type UpdateTagInput = z.infer<typeof updateTagSchema>;
export type ListTagsInput = z.infer<typeof listTagsSchema>;
export type TagIdInput = z.infer<typeof tagIdSchema>;
export type AssignTagInput = z.infer<typeof assignTagSchema>;
export type RemoveTagInput = z.infer<typeof removeTagSchema>;
export type ListKlientTagsInput = z.infer<typeof listKlientTagsSchema>;
export type BulkAssignTagsInput = z.infer<typeof bulkAssignTagsSchema>;
